/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage, RequireAuthExternal } from 'sarsaparilla';
import { MobileSessionHandoff } from 'shared-ui/mobile-session';

import PermitVenuePage from '../src/containers/PermitVenuePage';
import DivisionDetailsPage from '../src/containers/DivisionDetailsPage';
import QuestionnairePage from '../src/containers/QuestionnairePage';
import AvailabilityPage from '../src/containers/AvailabilityPage';
import PermitRegistrationPage from '../src/containers/PermitRegistrationPage';
import SelectCooperatorPage from '../src/containers/SelectCooperatorPage';
import CartlessConfirmationPage from '../src/containers/CartlessConfirmationPage';
import TertiaryContentPage from '../src/containers/TertiaryContentPage';

import routesArray from './routesArray';

const Components = {
    PermitVenuePage,
    DivisionDetailsPage,
    QuestionnairePage,
    AvailabilityPage,
    PermitRegistrationPage,
    SelectCooperatorPage,
    CartlessConfirmationPage,
    TertiaryContentPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RequireAuthExternal>
                            <Component />
                        </RequireAuthExternal>
                    }
                />
            );
        }
        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    // needed for mobile app to prevent login redirects
    routeComponents.push(
        <Route
            path="/permits/:permitId/mobile/session"
            key="mobileSession"
            element={<MobileSessionHandoff />}
        />
    );

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
